export var VendorType;
(function (VendorType) {
    VendorType["ETC"] = "ETC";
    VendorType["INSURER"] = "INSURER";
    VendorType["ACCOMMODATION"] = "ACCOMMODATION";
    VendorType["AGENCY"] = "AGENCY";
    VendorType["COUPON"] = "COUPON";
})(VendorType || (VendorType = {}));
